var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      style: _vm.css,
      attrs: {
        disabled: _vm.disabled,
        filterable: "",
        remote: "",
        "value-key": "id",
        "remote-method": _vm.loadOrderList,
        placeholder: "输入商家名或店铺名或订单号搜索订单信息",
        clearable: ""
      },
      on: { change: _vm.onChange },
      model: {
        value: _vm.order,
        callback: function($$v) {
          _vm.order = $$v
        },
        expression: "order"
      }
    },
    _vm._l(_vm.orderList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.label, value: item }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6875076", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6875076","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/MerchantOrderSearchComplex.vue
// module id = 820
// module chunks = 75